import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../Assets/writeme.png";
import Profile from "../../Assets/man.jpg";
import Spinner from "../../Components/Spinner/Spinner";
import { toast } from "react-toastify";
import axios from "axios";
import baseUrl from "../../baseUrl";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [avatar, setAvatar] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const imageChange = (e) => {
    const file = e.target.files[0];
    if (file.size >= 1048576) {
      toast.error("File size too large, maximum size is 1MB");
      setAvatar();
    } else {
      setAvatar(e.target.files[0]);
    }
  };

  const removeAvatar = () => {
    setAvatar();
  };

  const handleSignup = (e) => {
    e.preventDefault();

    if (!email || !fullName || !phoneNumber || !address || !password) {
      toast.error("Please fill all fields.");
    } else if (!avatar) {
      toast.error("Please select an avatar.");
    } else {
      setLoading(true);
      const formData = new FormData();
      formData.append("fullName", fullName);
      formData.append("email", email);
      formData.append("phoneNumber", phoneNumber);
      formData.append("address", address);
      formData.append("avatar", avatar);
      formData.append("gender", gender);
      formData.append("dob", dob);
      formData.append("password", password);

      axios
        .post(`${baseUrl}/user/signup`, formData)
        .then((response) => {
          if (response.data.success === true) {
            localStorage.setItem(
              "user-token",
              JSON.stringify(response.data.token)
            );
            toast.success(response.data.message);
            navigate("/verify-email");
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    }
  };
  return (
    <>
      {loading && <Spinner />}
      <div className="min-h-screen p-5 flex justify-center items-center">
        <form
          onSubmit={handleSignup}
          className="py-3 px-12 bg-gray-200 rounded-2xl shadow-xl z-20"
        >
          <div className="flex flex-col">
            <Link to="/">
              <img
                src={Logo}
                className="align-middle mx-auto"
                width="70px"
                height="70px"
                alt="logo"
                draggable="false"
              />
            </Link>
            <h1 className="text-3xl capitalize font-bold text-center mb-4 ">
              Create new account
            </h1>
          </div>
          <div className="flex flex-col pb-5">
            {avatar ? (
              <div className="relative align-middle mx-auto">
                <img
                  className="w-16 h-16 rounded-full"
                  src={URL.createObjectURL(avatar)}
                  alt="avatar"
                />
                <span
                  onClick={removeAvatar}
                  className="top-0 left-12 absolute  w-3.5 h-3.5 cursor-pointer border-2 border-white rounded-full"
                >
                  <i className="fa-solid fa-circle-xmark text-red-600"></i>
                </span>
              </div>
            ) : (
              <div className="relative align-middle mx-auto">
                <img
                  className="w-16 h-16 rounded-full"
                  src={Profile}
                  alt="avatar"
                />
                <span className="top-0 left-12 absolute   w-3.5 h-3.5 cursor-pointer border-2 border-white rounded-full">
                  <input
                    type="file"
                    name="avatar"
                    accept="image/*"
                    onChange={imageChange}
                    className="cursor-pointer"
                    hidden
                    id="image-upload"
                  />
                  <label htmlFor="image-upload">
                    <i className="fa-solid fa-plus text-green-700 cursor-pointer"></i>
                  </label>
                </span>
              </div>
            )}
          </div>
          <div className="space-y-4">
            <input
              type="text"
              name="fullName"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="Full Name"
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
              required
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Address"
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
              required
            />
            <input
              type="number"
              name="phoneNumber"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Phone Number"
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
              required
            />
            <input
              type="text"
              name="address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Full Address"
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
              required
            />
            <input
              type="date"
              placeholder="Date of Birth"
              name="dob"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
              required
            />{" "}
            <div
              className="grid w-[40rem] grid-cols-4 space-x-2 rounded-xl mb-1 bg-gray-200 p-2"
              x-data="app"
            >
              <div>
                <label
                  htmlFor="gender"
                  className="block cursor-pointer select-none rounded-xl p-2 text-center bg-gray-500 text-white "
                >
                  Gender
                </label>
              </div>
              <label className="flex radio p-2 cursor-pointer">
                <input
                  className="my-auto transform scale-125"
                  type="radio"
                  id="male"
                  name="gender"
                  value="Male"
                  onChange={(e) => {
                    setGender(e.target.value);
                  }}
                />
                <div className="title px-2">Male</div>
              </label>
              <label className="flex radio p-2 cursor-pointer">
                <input
                  className="my-auto transform scale-125"
                  type="radio"
                  id="female"
                  name="gender"
                  value="Female"
                  onChange={(e) => {
                    setGender(e.target.value);
                  }}
                />
                <div className="title px-2">Female</div>
              </label>
              <label className="flex radio p-2 cursor-pointer">
                <input
                  className="my-auto transform scale-125"
                  type="radio"
                  id="other"
                  name="gender"
                  value="Other"
                  onChange={(e) => {
                    setGender(e.target.value);
                  }}
                />
                <div className="title px-2">Other</div>
              </label>
            </div>
            <input
              type="password"
              placeholder="Password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
              required
            />
          </div>
          <div className="text-center mt-6">
            <button
              className="py-3 w-64 text-xl text-white bg-cyan-500 rounded-2xl"
              type="submit"
            >
              {loading ? "Signing Up..." : "Sign Up"}
            </button>
            <p className="mt-4 text-sm">
              Already have an account?
              <span className="underline cursor-pointer ml-2">
                <Link to="/signin">Sign In</Link>
              </span>
            </p>
          </div>
        </form>
      </div>
    </>
  );
};

export default Signup;
